export enum RankingRuleActionType {
  Boost = 'boost',
  Bury = 'bury',
}
